import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';

import { useQueries } from '@test_prep/app/queries';

import WritingScoreReport from './writing';

const ShowScoreReport: React.FC<{}> = (props) => {
  const { id } = useParams();
  const q = useQueries();

  const pagePath = paths.answerScoreReport(id);
  const page = q.pageQuery(pagePath).data;

  const breadcrumbs = [
    { name: 'Home', path: paths.dashboard() },
    { name: 'Score Report' }
  ];

  if (!page) {
    return (
      <div style={{ position: 'relative' }}>
        <Helmet>
          <title>Score Report</title>
        </Helmet>

        <CardLayout breadcrumbs={breadcrumbs} loading />
      </div>
    );
  } else {
    return (
      <div style={{ position: 'relative' }}>
        <Helmet>
          <title>
            {
              page.scoreReport.reportType ? (
                `${page.scoreReport.reportType} Score Report`
              ) : 'Score Report'
            }
          </title>
        </Helmet>

        <WritingScoreReport {...page} />
      </div>
    );
  }
};

export default ShowScoreReport;
